import { useCallback, useState } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useSessionTimeout } from '@/features/auth/hooks/useSessionTimeout';
import { Modal, useSpinner } from '@chikara/ui';
import { APP_CONFIG } from '@/config';
import styles from './SessionTimeoutManager.module.css';
import { t } from '@/i18n';

const IDLE_TIMEOUT_MS = APP_CONFIG.session.idleTimeoutMs;
const WARNING_DURATION_MS = APP_CONFIG.session.warningDurationMs;

export function SessionTimeoutManager() {
  const { isAuthenticated, logout, refreshToken } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);
    const { show, hide } = useSpinner();
  

  const handleTimeout = useCallback(() => {
    logout();
  }, [logout]);

  const { isWarning, countdown, resetTimer } = useSessionTimeout(
    IDLE_TIMEOUT_MS,
    WARNING_DURATION_MS,
    handleTimeout
  );

  const handleKeepSession = useCallback(async () => {
    if (isRefreshing) return;
    show()

    setIsRefreshing(true);
    try {
      await refreshToken();
      resetTimer();
    } catch {
      // refreshToken triggers logout on failure
    } finally {
      setIsRefreshing(false);
      hide()
    }
  }, [isRefreshing, refreshToken, resetTimer]);

  if (!isAuthenticated || !isWarning) {
    return null;
  }

  return (
    <Modal
      isOpen={isWarning}
      onClose={handleKeepSession}
      title={t('sessionTimeout.title')}
      actionLabel={t('sessionTimeout.action')}
      onAction={logout}
      secondaryActionLabel={t('sessionTimeout.secondaryAction')}
      onSecondaryAction={handleKeepSession}
      secondaryActionVariant="button"
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseButton={false}
    >
      <div className={styles.container}>
        <div className={styles.timerCircle}>
          <span className={styles.timerNumber}>{countdown}</span>
          <span className={styles.timerUnit}>{t('sessionTimeout.timerUnit')}</span>
        </div>
        <p className={styles.description}>{t('sessionTimeout.description')}</p>
      </div>
    </Modal>
  );
}
